import { useEffect } from "react";

import {
    AnchorContentsResponse,
    PaidLandingPersonaTypes
} from "@/utils/anchor-queries/get-anchor-contents";
import { experiments, useExperimentExposure } from "@/utils/experiment";

import { JiraSoftwarePagePaidLpJsmAnchor } from "./paid-lp-jsm-anchor";

export interface JiraSoftwarePagePaidLpJsmAssetProps {
    anchorContents?: AnchorContentsResponse | null;
    persona?: string;
}

export const JiraServiceManagementSoftwarePageAnchorLpJsmAsset = (
    pageProps: JiraSoftwarePagePaidLpJsmAssetProps
) => {
    const [cpapiDeprecationExposureFired, fireCpapiDeprecationExposure] =
        useExperimentExposure(experiments.cpapiDeprecationJsmExperiment);

    useEffect(() => {
        if (!cpapiDeprecationExposureFired) {
            fireCpapiDeprecationExposure();
        }
    }, [cpapiDeprecationExposureFired, fireCpapiDeprecationExposure]);

    return (
        <JiraSoftwarePagePaidLpJsmAnchor
            {...pageProps}
            pageId="anchor-lp-jsm-asset"
            persona={"unknown" as PaidLandingPersonaTypes}
            pageVariant="asset"
        />
    );
};
